<template>
  <div class="home">
    <ProductTemplateList v-show="listView" @newTemplate="onClickNewFromList" @editTemplate="onClickEditFromList" :scroll="corY" ref="refreshList"/>
    <ProductTemplateForm v-show="formView" :template="template"  @backClicked="onBackChild" />
  </div>
</template>

<script>
// @ is an alias to /src
import ProductTemplateList from '@/components/product/ProductTemplateList.vue'
import ProductTemplateForm from '@/components/product/ProductTemplateForm.vue'

export default {
  name: 'ProductTemplate',
  components: {
    ProductTemplateList,
    ProductTemplateForm
  },
  data () {
    return {
      corX: 0,
      corY: 0,
      listView: true,
      formView: false,
      template: {
        id: null,
        template_no: null,
        name: null,
        template_date: null,
        notes: null,
        active: false,
        details: [{
          id: null,
          template_id: null,
          product_no: null,
          qty: 0,
          uom_id: null,
          uomList: [{
            id: null,
            name: null,
            category_id: null,
            type_id: null,
            ratio: null,
            active: null,
            cost: '0',
            price: '0'
          }]
        }]
      }
    }
  },
  methods: {
    onClickEditFromList: function (value) {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.template = value
    },
    onClickNewFromList: function () {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.template = {
        id: null,
        template_no: null,
        name: null,
        template_date: null,
        notes: null,
        active: false,
        details: [{
          template_id: null,
          product_no: null,
          qty: 0,
          uom_id: null,
          uomList: [{
            id: null,
            name: null,
            category_id: null,
            type_id: null,
            ratio: null,
            active: null,
            cost: '0',
            price: '0'
          }]
        }]
      }
    },
    async onBackChild () {
      window.scrollTo(this.corX, this.corY)
      this.listView = true
      this.formView = false
      this.template = {
        id: null,
        template_no: null,
        name: null,
        template_date: null,
        notes: null,
        active: false,
        details: [{
          id: null,
          template_id: null,
          product_no: null,
          qty: 0,
          uom_id: null,
          uomList: [{
            id: null,
            name: null,
            category_id: null,
            type_id: null,
            ratio: null,
            active: null,
            cost: '0',
            price: '0'
          }]
        }]
      }
      await this.$refs.refreshList.refreshList()
      await window.scrollTo(this.corX, this.corY)
      console.log('window.scrollTo:' + this.corY)
    }
  },
  mounted () {
    this.$store.dispatch('getProductList')
  }
}
</script>
